/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import axios from '../plugins/axios';
import TelemetryFilters from './filters/telemetry';
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  state: {
    user: null,
    projects: [],
    currProjectId: localStorage.getItem('current-project-id') || null,
    currProject: { db: '' },
    selectedTimelineEvents: JSON.parse(localStorage.getItem('selected-timeline-events') || '[]') ,
    referenceSettings: JSON.parse(localStorage.getItem('reference-settings') || '{}' ),
    timelineSpeed: localStorage.getItem('timeline-speed') || 1,
    platforms: [],
    project_config: { world: 'open world' }
  },

  getters: {
    wsProjectPath: (state) => '/ws/project/' + state.currProject.db,
    projectPath: (state) => '/api/project/' + state.currProject.db,
    defaultPlatform: (state) =>
      state.platforms.filter(platform => platform.default)[0] || { name: 'Win64', default: true },
  },

  mutations: {
    ['SET_USER'](state, user) {
      state.user = user
    },
    ['SET_PROJECTS'](state, projects) {
      state.projects = projects
    },
    ['SET_CURRENT_PROJECT'](state, currProjectId) {
      state.currProjectId = currProjectId;
      state.currProject = state.projects.find(project => project.id == currProjectId) || { project_name: 'Unset project' };
    },
    ['SET_PLATFORMS'](state, platforms) {
      state.platforms = platforms;
    },
    ['UPDATE_PLATFORMS'](state, { platform, index }) {
      if (index > -1) {
        state.platforms.splice(index, 1, platform);
      } else {
        state.platforms.push(platform);
      }
    },
    ['UPDATE_PROJECT_CONFIG'](state, data) {
      state.project_config = data
    },
    ['UPDATE_SELECTED_TIMELINE_EVENTS'](state, data) {
      state.selectedTimelineEvents = data
      localStorage.setItem('selected-timeline-events', JSON.stringify(data))
    },
    ['UPDATE_TIMELINE_SPEED'](state, data) {
      state.timelineSpeed = data
      localStorage.setItem('timeline-speed', data)
    },
    ['UPDATE_REFERENCE_SETTINGS'](state, data) {
      state.referenceSettings = data
      localStorage.setItem('reference-settings', JSON.stringify(data))
    }
  },

  actions: {
    async authUser({ commit, dispatch }) {
      try {
        const { data } = await axios.get('/api/auth');

        commit('SET_CURRENT_PROJECT', data.project_id)
        commit('SET_USER', data);
        commit('UPDATE_SELECTED_TIMELINE_EVENTS', JSON.parse(data.selected_timeline_events))
        commit('UPDATE_TIMELINE_SPEED', data.timeline_speed)

        await dispatch('getProjects');
        await dispatch('getPlatforms');
        await dispatch('projectConfig');
      } catch(err) {
        console.log('Auth user failed: ' + err.message);
      }
    },
    async login({ commit, dispatch }, data) {
      localStorage.setItem('Authorization', data.token)
      axios.defaults.headers.Authorization = data.token

      commit('SET_USER', { ...data.user, logined: true })
      commit('SET_CURRENT_PROJECT', data.user.project_id)
      commit('UPDATE_SELECTED_TIMELINE_EVENTS', JSON.parse(data.user.selected_timeline_events || '[]'))
      commit('UPDATE_REFERENCE_SETTINGS', JSON.parse(data.user.reference_settings || '{}'))
      commit('UPDATE_TIMELINE_SPEED', data.user.timeline_speed)

      await dispatch('getProjects', true);
      await dispatch('getPlatforms');
      await dispatch('projectConfig');
    },
    async logout({ commit }) {
      localStorage.clear();
      commit('SET_USER', null);
    },
    async getProjects({ commit, dispatch }, isLogin) {
      try {
        let { data } = await axios.get('/api/projects');
        commit('SET_PROJECTS', data);
        await dispatch('initCurrentProject', isLogin);
      } catch(err) {
        console.log('Get projects failed: ' + err.message);
      }
    },
    async initCurrentProject({ state, commit, dispatch }, isLogin) {
      if (state.currProjectId && state.projects.some(pr => pr.id == state.currProjectId)) {
        commit('SET_CURRENT_PROJECT', state.currProjectId)
      } else {
        await dispatch('setCurrentProject', state.projects[state.projects.length - 1].id, isLogin)
      }
    },
    async setCurrentProject({ state, commit }, project_id, isLogin) {
      localStorage.setItem('current-project-id', project_id)
      commit('SET_USER', { ...state.user, project_id })
      await axios.post('/api/user/update', { project_id })
      if (!isLogin) {
        window.location.reload(true);
      }
    },
    async getPlatforms({ getters, commit }) {
      try {
        let { data } = await axios.get(getters.projectPath + '/platforms');
        commit('SET_PLATFORMS', data);
      } catch(err) {
        console.log('Get platforms list failed: ' + err.message);
      }
    },
    async createPlatform({ getters, commit }, platform) {
      try {
        let { data } = await axios.post(getters.projectPath + '/platforms', platform);
        commit('UPDATE_PLATFORMS', { platform: data })
      } catch(err) {
        console.log('Can\'t update platform: ' + err.message);
      }
    },
    async updatePlatform({ getters, commit }, { platform, index }) {
      try {
        let { data } = await axios.put(getters.projectPath + '/platforms/' + platform.id, platform);
        commit('UPDATE_PLATFORMS', { platform: data, index })
      } catch(err) {
        console.log('Can\'t update platform: ' + err.message);
      }
    },
    async setDefaultPlatform({ getters, state, commit }, { platform }) {
      try {
        const platforms = state.platforms.map(pl =>
          pl.id == platform.id && platform.default ? platform : { ...pl, default: false}
        );
        await axios.put(getters.projectPath + '/platforms', platforms);
        commit('SET_PLATFORMS', platforms);
      } catch(err) {
        console.log('Can\'t set default platform: ' + err.message);
      }
    },
    async projectConfig({ getters, commit }) {
      try {
        let { data } = await axios.get(getters.projectPath + '/project-config');
        commit('UPDATE_PROJECT_CONFIG', data)
      } catch(err) {
        console.log('Can\'t get project config: ' + err.message);
      }
    },
    async updateProjectConfig({ getters, commit, state }, data) {
      const body = { ...state.project_config, ...data }
      try {
        let { data } = await axios.put(getters.projectPath + '/project-config', body);
        commit('UPDATE_PROJECT_CONFIG', data)
      } catch(err) {
        console.log('Can\'t update project config: ' + err.message);
      }
    },
    async updateSelectedTimelineEvents({ commit }, data) {
      try {
        await axios.post('/api/user/update', { selected_timeline_events: JSON.stringify(data) })
        commit('UPDATE_SELECTED_TIMELINE_EVENTS', data)
      } catch (err) {
        console.log('Can\'t update config: ' + err.message)
      }

    },
    async updateTimelineSpeed({ commit }, data) {
      try {
        await axios.post('/api/user/update', { timeline_speed: data })
        commit('UPDATE_TIMELINE_SPEED', data)
      } catch (err) {
        console.log('Can\'t update config: ' + err.message)
      }
    },
    async updateReferenceSettings({ commit, state }, data) {
      try {
        await axios.post('/api/user/update', { reference_settings: JSON.stringify({ [state.currProject.db]: data }) })
        commit('UPDATE_REFERENCE_SETTINGS', { [state.currProject.db]: data })
      } catch (err) {
        console.log('Can\'t update reference settings: ' + err.message)
      }
    },
  },
  strict: debug,
})

store.registerModule(['telemetry'], TelemetryFilters)

export default store;
